import React, { useState, useEffect } from "react";
import { withRouter } from '../../common/withRouter';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
    DataDefinitionList,
    Notification,
    ButtonOBSOLETED,
    Message,
    Loader
} from "../../web.common";
import withApi from "../higherOrderComponents/withApi";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import { DisplayDate, DisplayGuid, DisplayType } from "../items";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import { Divider, DetailsRightBar, NoLink, Action } from './DetailsRightBar';

const ExternalPurchaseAttemptInternal = (
    {
        api,
        match: {
            params: { attemptId },
        }
    }
) => {
    const [data, setData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const attemptStatus = {
        0: "Undefined",
        1: "Pending",
        2: "Failed",
        4: "Success",
        5: "Cancellation success",
        6: "Cancellation failed",
    };

    useEffect(() => {
        async function loadFromApi() {
            const attempt = await api.externalPurchaseAttempt.getExternalPurchaseAttemptById(attemptId);

            setData(attempt.data);
        }

        if (!data) {
            loadFromApi();
        }
    }, []);

    const formatErrorText = (errorText) => {
        const jsonStart = errorText.indexOf('{');
        const jsonEnd = errorText.lastIndexOf('}') + 1;

        let parsedJson= null;
        let formattedJson = '';

        if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
            try {
                parsedJson = JSON.parse(errorText.slice(jsonStart, jsonEnd));
                formattedJson = JSON.stringify(parsedJson, null, 2);
            } catch {
                formattedJson = 'Could not parse JSON.';
            }
        }

        return (
            <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', overflowX: 'auto' }}>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {errorText.slice(0, jsonStart)}
                </div>
                {formattedJson && (
                    <pre
                        style={{
                            background: '#f5f5f5',
                            padding: '8px',
                            borderRadius: '4px',
                            marginTop: '0.5em',
                            marginBottom: '0.5em',
                            overflowX: 'auto',
                            display: 'block'
                        }}
                    >
                        {formattedJson}
                    </pre>
                )}
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {errorText.slice(jsonEnd)}
                </div>
            </div>
        );
    }

    return (
        <LayoutContext.Consumer>
            {() => (
                <React.Fragment>
                    <Notification newMessage={errorMessage} />
                    <PageTop
                        documentTitle={`External Purchase Attempt`}
                        documentDescription={`External Purchase Attempt`}
                    />
                    {data ? (
                        <React.Fragment>
                            <h2 className='main-page-header main-page-header-with-subheader'>
                                External Purchase Attempt
                            </h2>
                            <br/>
                            <DataDefinitionList
                                listData={{
                                        'Attempt Id': data.id,
                                    'Signup Id': <DisplayGuid baseAnchor={'../signup'} >{data.signupId}</DisplayGuid>,
                                        'Started At': <DisplayDate>{data.startedAt}</DisplayDate>,
                                        'Ended At': <DisplayDate>{data.endedAt || '-'}</DisplayDate>,
                                        'External Purchase Id': <DisplayGuid baseAnchor='/externalpurchase'>{data.externalPurchaseId}</DisplayGuid>,
                                        'Result': attemptStatus[data.result] || 'Unknown',
                                        'Error Text': data.errorText ? formatErrorText(data.errorText) : '-',
                                }}
                                classNames={['detail-page-list']}
                            />
                            
                            <DetailsRightBar>
                                <Divider>Links</Divider>
                                <NoLink>None</NoLink>
                                <Divider>Actions</Divider>
                            </DetailsRightBar>
                        </React.Fragment>
                    ) :
                        <Loader />
                    }
                </React.Fragment>
            )}
        </LayoutContext.Consumer>
    );
};

const ExternalPurchaseAttempt = withRouter(
    withApi(
        connect(
            ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
            {}
        )(ExternalPurchaseAttemptInternal)
    )
);

ExternalPurchaseAttempt.requiresLogin = true;
ExternalPurchaseAttempt.propTypes = { isLoggedIn: PropTypes.bool };

export default ExternalPurchaseAttempt;
